const buildUrl = (path) => {
  return `${window.location.origin}${path}`
}

export const GET_PARTICIPANT = buildUrl('/.netlify/functions/participants')
export const CREATE_RESPONSE = buildUrl('/.netlify/functions/responses')
export const CREATE_ANONYMOUS_RESPONSE = buildUrl(
  '/.netlify/functions/anonymousResponses',
)
